import type { StatusLabel } from '../types';
import { LabelType } from './LabelType';

export const getBestLabelAsset2 = (transcode: StatusLabel, review: StatusLabel): StatusLabel => {
  if (transcode && (!review || transcode?.type !== LabelType.SUCCESS)) return transcode;

  return review;
};
